import React, { useState } from 'react';
import { Container, Grid, Box, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CommonRideView from './CommonRideView';
import UserDetails from './userDetails/UserDetails';

export default function Reservation() {

  return (
    <Box className="max-h-screen bg-gray-50">
      <div className='max-h-screen p-6 bg-white'>
        <CommonRideView />
      </div>
    </Box>
  );
}
